<template>
    <div>
        <v-dialog v-model="this.$store.state.textShow" hide-overlay persistent max-width="600">
            <div style="padding:20px;">
                <v-progress-linear indeterminate class="mb-0" v-if="$store.state.textLoading"></v-progress-linear>
                <slot slot="dialog-text"></slot>
                <div style="text-align: center" class="pre-formatted">{{this.$store.state.textMessage}}</div>
                <div style="text-align: center" class="mt-3">
                    <v-btn color="dark" @click="closeTextDialog">Ok</v-btn>
                </div>
            </div>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: "TextDialog",
        methods: {
            closeTextDialog() {
                this.$store.state.textShow = false;
                this.$store.state.textMessage = '';
            }
        }
    }
</script>

<style scoped>
    .pre-formatted {
        white-space: pre;
    }
</style>